// extracted by mini-css-extract-plugin
export default {"mainContReview":"Reviews_mainContReview__TKBW6","pro":"Reviews_pro__FMaJe","rDiv":"Reviews_rDiv__iBI87"};